import Images from '@themes/images';

// TA-10404 / TD-410: the subset and display order of IconStart* icons the
// product/design team curated for the project icon picker (Figma:
// https://www.figma.com/design/zSkhzMBD3c7fvC8H7D4jS6/Micro-UI-Elements?node-id=144-15176).
// Icons omitted here (e.g. IconStart24, the key icon) are still valid
// `project.icon` values for existing projects — they still resolve via
// `Images` — they're just no longer offered as a choice for new selections.
export const PROJECT_ICON_LIST: (keyof typeof Images)[] = [
  'IconStart22',
  'IconStart20',
  'IconStart21',
  'IconStart2',
  'IconStart12',
  'IconStart11',
  'IconStart36',
  'IconStart9',
  'IconStart32',
  'IconStart37',
  'IconStart34',
  'IconStart14',
  'IconStart10',
  'IconStart18',
  'IconStart30',
  'IconStart31',
  'IconStart38',
  'IconStart15',
  'IconStart39',
  'IconStart16',
  'IconStart17',
  'IconStart1',
  'IconStart0',
  'IconStart35',
  'IconStart8',
  'IconStart26',
  'IconStart19',
  'IconStart27',
  'IconStart29',
  'IconStart4',
  'IconStart28',
  'IconStart25',
];
